import { useEvaluateInAppQuery } from '../../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService.hooks';
import { useEvaluatePublicQuery } from '../../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService.hooks';
import { useIsInAppAuth } from '../../../v2/hooks/user/useUserInfo';
export const useSuitePurchaseMotionsQuery = ({
  productLevel,
  location,
  skip
}) => {
  var _purchaseMotionsQuery;
  // this actually works for pre-seats too because pre-seats purchase motion rpc returns the bundle sku
  const productApiName = `crm-suite-${productLevel.toLowerCase()}-bundle`;
  const isInAppAuth = useIsInAppAuth();
  const useEvaluateQuery = isInAppAuth ? useEvaluateInAppQuery : useEvaluatePublicQuery;
  const {
    data: purchaseMotionsQuery,
    loading,
    error
  } = useEvaluateQuery({
    variables: {
      productApiNames: [productApiName],
      locations: [location]
    },
    skip: productLevel === 'FREE' || skip
  });
  const purchaseMotions = purchaseMotionsQuery === null || purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = purchaseMotionsQuery.purchaseMotionsMapping) === null || _purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = _purchaseMotionsQuery.productsByLocationString) === null || _purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = _purchaseMotionsQuery[location]) === null || _purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = _purchaseMotionsQuery.purchaseMotionsByProductApiName) === null || _purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = _purchaseMotionsQuery[productApiName]) === null || _purchaseMotionsQuery === void 0 ? void 0 : _purchaseMotionsQuery.purchaseMotions;
  return {
    suitePurchaseMotions: purchaseMotions || [],
    loading,
    error
  };
};